const getPanelName = (parentPanel) => {
    let nextPanel = parentPanel;
    let nameFound = false;
    let panelName;
    while (!nameFound) {
        const { attributes } = nextPanel;
        if (attributes.panel_name) {
            panelName = attributes.panel_name;
            nameFound = true;
        }
        if (!nameFound) {
            const { panels: subPanels } = nextPanel;
            const isLastPanel = subPanels.length === 0;
            if (!isLastPanel) {
                const firstPanel = subPanels[0];
                nextPanel = firstPanel;
            }
            else {
                nameFound = true;
            }
        }
    }
    return panelName;
};
const findProductsFromPanel = (parentPanel) => {
    const { panels: subPanels, products } = parentPanel;
    const isLastPanel = (subPanels === null || subPanels === void 0 ? void 0 : subPanels.length) === 0;
    const subPanelProducts = [];
    if (isLastPanel) {
        return products;
    }
    subPanels === null || subPanels === void 0 ? void 0 : subPanels.forEach((subPanel) => {
        const prodsFromSubPanel = findProductsFromPanel(subPanel);
        if (prodsFromSubPanel && prodsFromSubPanel.length > 0) {
            subPanelProducts.push(...prodsFromSubPanel);
        }
    });
    return subPanelProducts;
};
const getProductsFromPanels = (panel) => {
    var _a;
    const allProducts = findProductsFromPanel(panel);
    return {
        products: allProducts,
        id: (_a = panel.attributes) === null || _a === void 0 ? void 0 : _a.panel_id,
        name: getPanelName(panel),
    };
};
const getProductsFromRecommendationLists = (recommendationList) => {
    return {
        products: recommendationList === null || recommendationList === void 0 ? void 0 : recommendationList.productList,
        id: recommendationList === null || recommendationList === void 0 ? void 0 : recommendationList.id,
        name: recommendationList === null || recommendationList === void 0 ? void 0 : recommendationList.label,
    };
};
const normalizeEsalesResponse = (PRAResponse, isE4Enabled = false) => {
    if (isE4Enabled) {
        const recommendationLists = PRAResponse === null || PRAResponse === void 0 ? void 0 : PRAResponse.recommendationLists;
        return recommendationLists.map(getProductsFromRecommendationLists);
    }
    const { panels } = PRAResponse;
    const panelsForNormalization = (panels === null || panels === void 0 ? void 0 : panels.length) === 1 ? panels[0].panels : panels;
    return panelsForNormalization === null || panelsForNormalization === void 0 ? void 0 : panelsForNormalization.map(getProductsFromPanels);
};
// this func is dependent on global variables that are not included in FE package
const mapDepartmentDetailsToRequest = (queryPayload) => {
    let categoryPath = '';
    if (queryPayload) {
        return {
            department_category_path: queryPayload.departmentCategoryPath,
            displayed_default_articles: queryPayload.displayedDefaultArticles,
            category_parent_key: queryPayload.categoryParentKey,
        };
    }
    if (typeof departmentCategoryPaths !== 'undefined') {
        categoryPath = departmentCategoryPaths;
        // eslint-disable-next-line @typescript-eslint/naming-convention
    }
    else if (typeof utag_data !== 'undefined') {
        categoryPath = utag_data.category_id || '';
    }
    return {
        department_category_path: categoryPath,
        displayed_default_articles: typeof displayedDefaultArticles !== 'undefined' ? displayedDefaultArticles : '',
        category_parent_key: typeof categoryParentKey !== 'undefined' ? categoryParentKey : '',
    };
};
const mapSearchDetailsToRequest = () => ({
    cart: typeof searchProductAsCart !== 'undefined' && searchProductAsCart ? searchProductAsCart : '',
});
// TODO: split to separate files to improve readability
export { mapDepartmentDetailsToRequest, normalizeEsalesResponse, getPanelName, mapSearchDetailsToRequest, findProductsFromPanel, };
//# sourceMappingURL=dataHandling.js.map